// ABOUTME: Translated labels for the job lifecycle values: job and attempt states, attempt failure
// ABOUTME: reasons, triggers and skip reasons. Unknown values fall back to the raw string.

import { defineMessages, MessageDescriptor, useIntl } from 'react-intl';

const jobStates = defineMessages({
    queued: { id: 'job.state.queued', defaultMessage: 'Queued' },
    running: { id: 'job.state.running', defaultMessage: 'Running' },
    retrying: { id: 'job.state.retrying', defaultMessage: 'Retrying' },
    succeeded: { id: 'job.state.succeeded', defaultMessage: 'Succeeded' },
    failed: { id: 'job.state.failed', defaultMessage: 'Failed' },
    cancelled: { id: 'job.state.cancelled', defaultMessage: 'Cancelled' },
    skipped: { id: 'job.state.skipped', defaultMessage: 'Skipped' },
});

const attemptStates = defineMessages({
    pending: { id: 'job.attempt.state.pending', defaultMessage: 'Pending' },
    running: { id: 'job.attempt.state.running', defaultMessage: 'Running' },
    succeeded: { id: 'job.attempt.state.succeeded', defaultMessage: 'Succeeded' },
    failed: { id: 'job.attempt.state.failed', defaultMessage: 'Failed' },
    timedOut: { id: 'job.attempt.state.timedOut', defaultMessage: 'Timed out' },
    cancelled: { id: 'job.attempt.state.cancelled', defaultMessage: 'Cancelled' },
});

const attemptReasons = defineMessages({
    oom: { id: 'job.attempt.reason.oom', defaultMessage: 'Out of memory' },
    lost: { id: 'job.attempt.reason.lost', defaultMessage: 'Worker lost' },
    interrupted: { id: 'job.attempt.reason.interrupted', defaultMessage: 'Interrupted' },
    unschedulable: {
        id: 'job.attempt.reason.unschedulable',
        defaultMessage: 'Could not be scheduled',
    },
    image: { id: 'job.attempt.reason.image', defaultMessage: 'Image pull error' },
    exit: { id: 'job.attempt.reason.exit', defaultMessage: 'Exited with an error' },
});

const triggers = defineMessages({
    manual: { id: 'job.trigger.manual', defaultMessage: 'Manual' },
    schedule: { id: 'job.trigger.schedule', defaultMessage: 'Schedule' },
    retry: { id: 'job.trigger.retry', defaultMessage: 'Retry' },
    system: { id: 'job.trigger.system', defaultMessage: 'System' },
    api: { id: 'job.trigger.api', defaultMessage: 'API' },
});

const skipReasons = defineMessages({
    missed: { id: 'job.skipReason.missed', defaultMessage: 'Missed its start deadline' },
    concurrent: {
        id: 'job.skipReason.concurrent',
        defaultMessage: 'A previous run was still running',
    },
});

export const JOB_STATE_LABELS: Record<string, MessageDescriptor> = jobStates;
export const ATTEMPT_STATE_LABELS: Record<string, MessageDescriptor> = attemptStates;
export const ATTEMPT_REASON_LABELS: Record<string, MessageDescriptor> = attemptReasons;
export const JOB_TRIGGER_LABELS: Record<string, MessageDescriptor> = triggers;
export const JOB_SKIP_REASON_LABELS: Record<string, MessageDescriptor> = skipReasons;

const useLabel = (labels: Record<string, MessageDescriptor>) => {
    const intl = useIntl();
    return (value: string) => {
        const label = labels[value];
        return label ? intl.formatMessage(label) : value;
    };
};

export const useJobStateLabel = () => useLabel(JOB_STATE_LABELS);
export const useAttemptStateLabel = () => useLabel(ATTEMPT_STATE_LABELS);
export const useAttemptReasonLabel = () => useLabel(ATTEMPT_REASON_LABELS);
export const useJobTriggerLabel = () => useLabel(JOB_TRIGGER_LABELS);
export const useJobSkipReasonLabel = () => useLabel(JOB_SKIP_REASON_LABELS);
